import React from 'react';

// Imagens de exemplo para a seção de treinamentos/perícias
const periciaImages = [
  {
    src: process.env.PUBLIC_URL + "/images/pericias/1.jpg",
    alt: "NR-12 Segurança na Operação e manutenção de máquinas"
  },
  {
    src: process.env.PUBLIC_URL + "/images/pericias/2.jpg",
    alt: "EPIs, sua Utilização e manutenção corretas"
  },
  {
    src: process.env.PUBLIC_URL + "/images/pericias/3.jpg",
    alt: "Segurança na utilização e manutenção correta de motosserras, Roçadeiras e sopradores à Bateria"
  },
  {
    src: process.env.PUBLIC_URL + "/images/pericias/4.jpg",
    alt: "Ergonomia no Trabalho com Máquinas e Ferramentas"
  },
  {
    src: process.env.PUBLIC_URL + "/images/pericias/5.jpg",
    alt: "Linha profissíonal à bateria Husqvarna e a ergonomia - conformidade com a NR-17"
  }
];

const engineeringServices = [
  {
    title: "LTCAT - Laudo Técnico das Condições Ambientais do Trabalho",
    description: "Avaliação completa das condições ambientais para aposentadoria especial."
  },
  {
    title: "PPRA - Programa de Prevenção de Riscos Ambientais",
    description: "Identificação e controle de riscos físicos, químicos e biológicos."
  },
  {
    title: "PCMSO - Programa de Controle Médico de Saúde Ocupacional",
    description: "Programa médico para preservação da saúde dos trabalhadores."
  },
  {
    title: "eSocial - Adequação e Implementação",
    description: "Adequação completa aos requisitos do eSocial para SST."
  },
  {
    title: "Análise de Riscos Ocupacionais",
    description: "Identificação, avaliação e controle de riscos no ambiente de trabalho."
  },
  {
    title: "Gestão de SST",
    description: "Consultoria completa em Segurança e Saúde do Trabalho."
  }
];

const expertiseServices = [
  {
    title: "Perícias Trabalhistas",
    description: "Laudos técnicos para processos judiciais trabalhistas."
  },
  {
    title: "Perícias de Insalubridade",
    description: "Avaliação técnica de condições insalubres no trabalho."
  },
  {
    title: "Perícias de Periculosidade",
    description: "Análise de atividades e condições perigosas."
  },
  {
    title: "Assistência Técnica",
    description: "Suporte técnico especializado em perícias judiciais e extrajudiciais."
  }
];

const trainingServices = [
  {
    title: "Uso Seguro de Motosserras Husqvarna",
    description: "Treinamento completo com foco na NR-12 e ergonomia."
  },
  {
    title: "Operação Segura de Roçadeiras",
    description: "Técnicas corretas e seguras para uso de roçadeiras."
  },
  {
    title: "Utilização Segura de máquinas e ferramentas",
    description: "Prevenção de lesões através de técnicas ergonômicas."
  },
  {
    title: "NR-12 - Segurança em Máquinas",
    description: "Treinamento completo sobre a norma regulamentadora."
  },
  {
    title: "NR-06 - Equipamentos de Proteção Individual",
    description: "Uso correto e manutenção de EPIs."
  },
  {
    title: "NR-17 - Trabalho com Ergonomia",
    description: "Ergonomia e a longevidade profissional."
  }
];

const Pericia = () => (
  <div className="pt-24">
    {/* Hero Section */}
    <section className="py-16 bg-husqvarna-light-gray text-center">
      <h1 className="text-4xl md:text-5xl font-bold text-husqvarna-dark-gray mb-6">Perícias e Segurança do Trabalho</h1>
      <p className="text-lg md:text-xl text-husqvarna-dark-gray/80 max-w-2xl mx-auto">
        Soluções completas em Engenharia de Segurança do Trabalho, Perícias Técnicas e Treinamentos especializados. Garantimos laudos, consultoria e treinamentos para empresas e profissionais.
      </p>
    </section>

    {/* Galeria de Imagens Temáticas de Perícia e Segurança */}
    <section className="py-10 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-husqvarna-dark-gray mb-6 text-center">
          Segurança, Ergonomia e Prática
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 mb-8">
          {periciaImages.map((img, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center rounded-xl overflow-hidden shadow-lg hover:scale-105 transition-transform duration-300 bg-white"
              style={{ minHeight: 0 }}
            >
              <div
                className="w-full flex items-center justify-center"
                style={{
                  aspectRatio: "4/3",
                  width: "100%",
                  maxWidth: "260px",
                  margin: "0 auto",
                  background: "#f3f4f6"
                }}
              >
                <img
                  src={img.src}
                  alt={img.alt}
                  className="object-contain w-full h-full"
                  style={{ maxHeight: "200px", maxWidth: "100%" }}
                  loading="lazy"
                  onError={e => { e.target.src = "https://via.placeholder.com/400x300?text=Imagem+Indisponível"; }}
                />
              </div>
              <p className="text-xs text-husqvarna-dark-gray/80 mt-2 text-center px-2">{img.alt}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Engenharia de Segurança do Trabalho */}
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-husqvarna-orange mb-8 text-center">Engenharia de Segurança do Trabalho</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {engineeringServices.map((service, idx) => (
            <div key={idx} className="bg-husqvarna-light-gray rounded-lg p-6 shadow hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-husqvarna-dark-gray mb-2">{service.title}</h3>
              <p className="text-husqvarna-dark-gray/80">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Perícias Técnicas */}
    <section className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-husqvarna-orange mb-8 text-center">Perícias Técnicas</h2>
        <div className="grid md:grid-cols-2 gap-8">
          {expertiseServices.map((service, idx) => (
            <div key={idx} className="bg-white rounded-lg p-6 shadow hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-husqvarna-dark-gray mb-2">{service.title}</h3>
              <p className="text-husqvarna-dark-gray/80">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* Cursos e Treinamentos */}
    <section className="py-12 bg-white">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-husqvarna-orange mb-8 text-center">Cursos e Treinamentos</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {trainingServices.map((service, idx) => (
            <div key={idx} className="bg-husqvarna-light-gray rounded-lg p-6 shadow hover:shadow-lg transition">
              <h3 className="text-xl font-semibold text-husqvarna-dark-gray mb-2">{service.title}</h3>
              <p className="text-husqvarna-dark-gray/80">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-16 bg-husqvarna-orange text-white text-center">
      <h2 className="text-3xl font-bold mb-4">Precisa de um laudo ou consultoria?</h2>
      <p className="text-lg mb-8">Entre em contato e saiba como podemos ajudar sua empresa a garantir segurança, saúde e conformidade legal.</p>
      <a
        href="/#contato"
        className="inline-block bg-white text-husqvarna-orange font-semibold px-8 py-3 rounded-full shadow hover:bg-husqvarna-light-gray transition"
      >
        Fale com um especialista
      </a>
    </section>

    {/* DICA: Verifique se a pasta e as imagens realmente existem em:
        public/images/pericias/1.jpg ... 5.jpg
        O caminho deve ser relativo à pasta public, não src.
        Exemplo de estrutura correta:
        public/images/pericias/1.jpg
        public/images/pericias/2.jpg
        public/images/pericias/3.jpg
        public/images/pericias/4.jpg
        public/images/pericias/5.jpg

        Se as imagens não existirem, crie arquivos de exemplo ou use placeholders temporários.
    */}
  </div>
);

export default Pericia;
